import { lazyImport } from '@/utils/lazyImport';
import { Navigate, Outlet, useRoutes } from 'react-router-dom';
import { Suspense } from 'react';
import { Spinner } from '@/components/Elements';
import SalesforceCallback from '@/features/settings/routes/SalesforceCallback';
import GainsightCallback from '@/features/settings/routes/GainsightCallback';
import { Register } from '@/features/auth/routes/Register';
import { ResetPassword } from '@/features/auth/routes/ResetPassword';
import GoogleSheetCallback from '../features/settings/routes/GoogleSheetsCallback';
import SlackCallback from '@/features/settings/routes/SlackCallback';
import EmailCallback from '@/features/settings/routes/EmailCallback';

const { AuthRoutes } = lazyImport(
  () => import('@/features/auth'),
  'AuthRoutes'
);

const SalesforceCallbackPage = () => {
  return (
    <SalesforceCallback>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </SalesforceCallback>
  );
};

const GainsightCallbackPage = () => {
  return (
    <GainsightCallback>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </GainsightCallback>
  );
};

const GoogleSheetsCallbackPage = () => {
  return (
    <GoogleSheetCallback>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </GoogleSheetCallback>
  );
};

const SlackCallbackPage = () => {
  return (
    <SlackCallback>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </SlackCallback>
  );
};

const EmailCallbackPage = () => {
  return (
    <EmailCallback>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </EmailCallback>
  );
};

const AppLoader = () => {
  <div className="h-full w-full flex items-center justify-center">
    <Spinner size="xl" />
  </div>;
};

export const commonRoutes = [
  { path: '/salesforce/callback', element: <SalesforceCallbackPage /> },
  { path: '/gainsight/callback', element: <GainsightCallbackPage /> },
  { path: '/slack/callback', element: <SlackCallbackPage /> },
  { path: '/auth/invite/accept', element: <Register /> },
  { path: '/auth/reset-password', element: <ResetPassword /> },
  {
    path: '/google-sheets/callback',
    element: <GoogleSheetsCallbackPage />,
  },
  {
    path: '/report/*',
    element: <EmailCallbackPage />,
  },
];

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthRoutes />,
  },
  { path: '*', element: <Navigate to="/auth/login" /> },
];

export const iframeRoutes = [{ path: '*', element: <AppLoader /> }];
